import React, { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { toast } from "sonner";
import { Lock, Mail, Loader2 } from "lucide-react";
import Seo from "../components/Seo";

export default function AdminLogin() {
  const { login, user } = useAuth();
  const nav = useNavigate();
  const [f, setF] = useState({ email: "", password: "" });
  const [loading, setLoading] = useState(false);

  if (user) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(f.email, f.password);
      toast.success("Welcome back!");
      nav("/admin");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Invalid credentials");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 px-4 pt-20">
      <Seo title="Admin Login" noindex path="/admin/login" />
      <div className="w-full max-w-md card-glass p-8">
        <img src="/logo.png" alt="Acchajee Travels" className="h-14 w-auto mx-auto mb-6 mix-blend-multiply" data-testid="admin-login-logo" />
        <h1 className="h2 text-center">Admin Login</h1>
        <p className="muted text-sm text-center mt-2 mb-8">Manage packages, leads, blog & testimonials</p>
        <form onSubmit={submit} className="space-y-4">
          <div className="flex items-center gap-3 bg-slate-50 rounded-xl px-4 py-3"><Mail className="w-4 h-4 text-slate-400" /><input type="email" required value={f.email} onChange={e => setF({ ...f, email: e.target.value })} placeholder="your admin email" className="bg-transparent flex-1 outline-none text-sm" data-testid="admin-email" /></div>
          <div className="flex items-center gap-3 bg-slate-50 rounded-xl px-4 py-3"><Lock className="w-4 h-4 text-slate-400" /><input type="password" value={f.password} onChange={e => setF({ ...f, password: e.target.value })} placeholder="Password" className="bg-transparent flex-1 outline-none text-sm" data-testid="admin-password" /></div>
          <button type="submit" disabled={loading} className="btn-primary w-full justify-center" data-testid="admin-submit">{loading ? <Loader2 className="w-4 h-4 animate-spin" /> : "Sign in"}</button>
        </form>
      </div>
    </div>
  );
}
